const queryString = require("query-string");

import { fetchGet } from "./serviceClient";
import { POST_META_TYPE } from "../constants/server";

export const fetchBlogDetails = async (slug) => {
  try {
    const blogs = await fetchGet(
      `${process.env.NEXT_PUBLIC_WORDPRESS_URL}/wp-json/wp/v2/posts?slug=${slug}`
    );

    const metaDataRequests = blogs.map((blog) =>
      fetchMetaDataForBlog(blog)
        .then((metaData) => {
          return {
            metaData,
            ...blog,
          };
        })
        .catch((err) => console.log(err.message))
    );

    const updatedBlogs = await Promise.all(metaDataRequests);
    return updatedBlogs
  } catch (err) {
    console.log(err.message);
    return;
  }
};

export const fetchAllBlogs = async () => {
  try {
    const res = await fetch(
      `${process.env.NEXT_PUBLIC_WORDPRESS_URL}/wp-json/wp/v2/posts?per_page=100`
    );
    const blogs = await res.json();
    return blogs;
  } catch (err) {
    console.log(err.message);
    return;
  }
};

export const fetchBlogsForCategory = async (categoryId) => {
  try {
    const res = await fetch(
      `${process.env.NEXT_PUBLIC_WORDPRESS_URL}/wp-json/wp/v2/posts?per_page=10&categories=${categoryId}`
    );
    const blogs = await res.json();

    const metaDataRequests = blogs.map((blog) =>
      fetchMetaDataForBlog(blog)
        .then((metaData) => {
          return {
            metaData,
            ...blog,
          };
        })
        .catch((err) => console.log(err.message))
    );

    const updatedBlogs = await Promise.all(metaDataRequests);
    return updatedBlogs;
  } catch (err) {
    console.log(err.message);
    return;
  }
};

export const fetchBlogsForTag = async (tagId) => {
  try {
    const res = await fetch(
      `${process.env.NEXT_PUBLIC_WORDPRESS_URL}/wp-json/wp/v2/posts?per_page=10&tags=${tagId}`
    );
    const blogs = await res.json();

    const metaDataRequests = blogs.map((blog) =>
      fetchMetaDataForBlog(blog)
        .then((metaData) => {
          return {
            metaData,
            ...blog,
          };
        })
        .catch((err) => console.log(err.message))
    );

    const updatedBlogs = await Promise.all(metaDataRequests);
    return updatedBlogs;
  } catch (err) {
    console.log(err.message);
    return;
  }
};

export const fetchMetaDataForBlog = async (blog) => {
  const metaData = {};

  const tagsRequest = fetch(
    `${process.env.NEXT_PUBLIC_WORDPRESS_URL}/wp-json/wp/v2/tags?per_page=100&post=${blog.id}`
  )
    .then((tagRes) => tagRes.json())
    .then((tags) => {
      if (tags) {
        metaData[POST_META_TYPE.TAGS] = tags.map((tag) => ({
          id: tag.id,
          name: tag.name,
          slug: tag.slug,
        }));
      }
    })
    .catch((err) => {
      console.log(err.message);
      return;
    });

  const featureMediaRequest = fetch(
    `${process.env.NEXT_PUBLIC_WORDPRESS_URL}/wp-json/wp/v2/media/${blog.featured_media}`
  )
    .then((mediaRes) => mediaRes.json())
    .then((image) => {
      if (image) {
        metaData[POST_META_TYPE.FEATURE_MEDIA] = {
          id: image.id,
          sourceUrl: image.source_url,
          width: image.media_details ? image.media_details.width : null,
          height: image.media_details ? image.media_details.height : null,
          alt: image.alt_text,
        };
      }
    })
    .catch((err) => {
      console.log(err.message);
      return;
    });

  const authorRequest = fetch(
    `${process.env.NEXT_PUBLIC_WORDPRESS_URL}/wp-json/wp/v2/users/${blog.author}`
  )
    .then((authorRes) => authorRes.json())
    .then((author) => {
      if (author) {
        metaData[POST_META_TYPE.AUTHOR] = {
          id: author.id,
          name: author.name,
          slug: author.slug,
          photo: author.avatar_urls["96"],
        };
      }
    })
    .catch((err) => {
      console.log(err.message);
      return;
    });

  await Promise.all([tagsRequest, featureMediaRequest, authorRequest]);

  return { ...metaData };
};

export const fetchBlogCategories = async () => {
  try {
    const paramsString = queryString.stringify({
      page: 1,
      per_page: 100,
    });

    const res = await fetch(
      `${process.env.NEXT_PUBLIC_WORDPRESS_URL}/wp-json/wp/v2/categories?${paramsString}`
    );

    const categories = await res.json();
    return categories;
  } catch (err) {
    console.log(err.message);
    return;
  }
};

export const fetchBlogTags = async () => {
  try {
    const paramsString = queryString.stringify({
      page: 1,
      per_page: 100,
    });

    const res = await fetch(
      `${process.env.NEXT_PUBLIC_WORDPRESS_URL}/wp-json/wp/v2/tags?${paramsString}`
    );

    const tags = await res.json();
    return tags;
  } catch (err) {
    console.log(err.message);
    return;
  }
};

export const fetchBlogsForCategorySlug = async (slug) => {
  try {
    const paramsString = queryString.stringify({
      slug,
      page: 1,
      per_page: 100,
    });

    const res = await fetch(
      `${process.env.NEXT_PUBLIC_WORDPRESS_URL}/wp-json/wp/v2/categories?${paramsString}`
    );

    const categories = await res.json();
    if (categories.length === 0) return [];

    const categoryId = categories[0].id;
    const blogs = await fetchBlogsForCategory(categoryId);
    return blogs;
  } catch (err) {
    console.log(err.message);
    return;
  }
};

export const fetchBlogsForTagSlug = async (slug) => {
  try {
    const paramsString = queryString.stringify({
      slug,
      page: 1,
      per_page: 100,
    });

    const res = await fetch(
      `${process.env.NEXT_PUBLIC_WORDPRESS_URL}/wp-json/wp/v2/tags?${paramsString}`
    );

    const tags = await res.json();
    if (tags.length === 0) return [];

    const tagId = tags[0].id;
    const blogs = await fetchBlogsForTag(tagId);
    return blogs;
  } catch (err) {
    console.log(err.message);
    return;
  }
};
